<!--
 * @Author: Lemon C
 * @Date: 2024-12-10 14:52:52
 * @LastEditTime: 2025-01-08 18:44:07
-->
<template>
    <div class="sup-banner-comp">
        <img class="banner-img" src="@/assets/imgs/devDoc/banner.png" alt="" />
        <div class="re-w1200 re-main-col">
            <div class="title-box">
                <span class="search-title">开发者文档</span>
                <span class="search-dis">提供详尽API文档和多终端SDK，完整且开放的开发者社区，帮助开发者快速上手</span>
            </div>
            <SearchBarLeftComp class="search-bar-left-comp" :search_bar_callback="search_bar_clickSearch"></SearchBarLeftComp>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref } from 'vue';
import SearchBarLeftComp from '@/components/Search/SearchBarLeftComp.vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

// MARK CallBack  搜索
const search_bar_clickSearch = (searchInput) => {
    router_store.navigateToSearch({ keywords: searchInput });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-banner-comp {
    position: relative;
    display: flex;
    justify-content: center;
    overflow: hidden;

    .banner-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        min-height: 100%;
    }

    .title-box {
        position: relative;
        margin-top: 150px;
        width: 100%;
        display: flex;
        flex-direction: column;

        .search-title {
            position: relative;
            width: 220px;
            height: 55px;
            font-size: 37px;
            font-weight: 500;
            color: var(--color-main-text-dark-bg-primary);
        }

        .search-dis {
            position: relative;
            margin-top: 16px;
            height: 28px;
            font-weight: 400;
            font-size: 20px;
            color: var(--color-main-text-dark-bg-secondary);
        }
    }

    .search-bar-left-comp {
        position: relative;
        margin-top: 72px;
        width: 100%;
    }
}
</style>
